import { render, staticRenderFns } from "./details-dialog.vue?vue&type=template&id=68d7c1b6&"
import script from "./details-dialog.vue?vue&type=script&lang=js&"
export * from "./details-dialog.vue?vue&type=script&lang=js&"
import style0 from "./details-dialog.vue?vue&type=style&index=0&id=68d7c1b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports